var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stay-overview-card" }, [
    _c("div", { staticClass: "stay-description" }, [
      _c("div", { staticClass: "stay-description-line box" }, [
        _c("div", { staticClass: "section-label" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.tc("noums.roomSingular")) +
              " " +
              _vm._s(_vm.index) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "overview-item guests" }, [
          _c("div", { staticClass: "item-label bold-item" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.stay.sitecoreContent.room.title) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "item-value section-label",
            domProps: { innerHTML: _vm._s(_vm.stayGuestsSummary) },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stay-privileges-info box" },
        [
          _c("div", { staticClass: "enhancements-overview-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("booking.complementaryPrivilages")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _vm.showPrivilegesEditButton
            ? [
                _c(
                  "a",
                  {
                    staticClass: "edit",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.editStay($event)
                      },
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.editStay($event)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.tc("booking.edit")))]
                ),
              ]
            : [
                _c("span", { staticClass: "disclaimer" }, [
                  _c("span", { staticClass: "icon-warning-red" }),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.tc(
                          "booking.modifyReservationComplimentaryPrivilegesUnavailable"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.enhancementsInRoom.length ? _c("hr") : _vm._e(),
      _vm._v(" "),
      _vm.enhancementsInRoom.length
        ? _c(
            "div",
            { staticClass: "stay-privileges box" },
            _vm._l(_vm.enhancementsInRoom, function (enhancement) {
              return _c(
                "div",
                {
                  key: enhancement.sitecoreId,
                  staticClass: "cart-enhancement",
                },
                [
                  _c("div", { staticClass: "enhancement-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(enhancement.enhancement.name) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  enhancement.summary
                    ? _c("div", {
                        staticClass: "enhancement-summary section-label",
                        domProps: { innerHTML: _vm._s(enhancement.summary) },
                      })
                    : _vm._e(),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.addOnsInRoom.length ? _c("hr") : _vm._e(),
    _vm._v(" "),
    _vm.addOnsInRoom.length
      ? _c(
          "div",
          { staticClass: "stay-add-ons box" },
          [
            _c("div", { staticClass: "stay-add-ons-title" }, [
              _vm._v("\n      " + _vm._s(_vm.addOnsTitle) + "\n    "),
            ]),
            _vm._v(" "),
            [
              _c(
                "a",
                {
                  staticClass: "edit",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.editStay($event)
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.editStay($event)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.tc("booking.edit")))]
              ),
            ],
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm._l(_vm.addOnsInRoom, function (addOn) {
              return _c(
                "div",
                { key: addOn.sitecoreId, staticClass: "stay-add-ons-item" },
                [
                  _c(
                    "div",
                    { staticClass: "stay-add-ons-item-info" },
                    [
                      _c("div", { staticClass: "stay-add-ons-item-title" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(addOn.addOnName) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stay-add-ons-item-price" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getAddOnPriceLabel(addOn)) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stay-add-ons-item-quantity" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.quantityLabel) +
                            ": " +
                            _vm._s(_vm.getTotalQuantity(addOn)) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.showAdultChildLabels(addOn)
                        ? [
                            addOn.adultQuantity
                              ? _c(
                                  "div",
                                  { staticClass: "stay-add-ons-item-quantity" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.adultLabel) +
                                        ": " +
                                        _vm._s(addOn.adultQuantity) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            addOn.childQuantity
                              ? _c(
                                  "div",
                                  { staticClass: "stay-add-ons-item-quantity" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.childLabel) +
                                        ": " +
                                        _vm._s(addOn.childQuantity) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      addOn.data.selectedAddOnDates &&
                      addOn.data.selectedAddOnDates.length > 1
                        ? [
                            _c(
                              "div",
                              { staticClass: "stay-add-ons-item-dates" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.datesLabel) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(
                              addOn.data.selectedAddOnDates,
                              function (date) {
                                return _c(
                                  "div",
                                  {
                                    key: date,
                                    staticClass: "stay-add-ons-item-date",
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.dateFormatted(date)) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "stay-add-ons-item-total" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getTotalPriceLabel(addOn)) +
                        "\n      "
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }